import apiService from "../../../../shared/service/api-service";
import { AppConfig } from "../../../../shared/app-configs/app-config";
import { TCAppConfig } from "../../../../shared/app-configs/tc-app-configs";
import { ICbLandingPageApiResponse, ICbLandingPageApiResponseETrackit } from "../tc-models/tc-req-dto/cb-landingpage.res_dto";
import { ETCAppConfig } from "../../../../shared/app-configs/etc-app-configs";
import { Utills } from "../../../../shared/app-configs/utilit";
export interface ICbLandingPageParams {
  tcCbLicensingCode: string;
  source?: string;
  paginations?: {
    pageIndex: number;
    pageSize: number;
  };
  startDate?: string;
  endDate?: string;
  country?: string;
}
export const cbLandingPageService = {
  async fetchCbLandingPageServiceRecords(
    params: ICbLandingPageParams
  ): Promise<ICbLandingPageApiResponse> {
    try {
      const response = await apiService.get<ICbLandingPageApiResponse>(
        TCAppConfig.CERTIFIED_TRANSACTION_DASHBOARD,
        params
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  },
  async fetchSuppliersLandingPageServiceRecords(
    params: any
  ): Promise<any> {
    try {
      const response = await apiService.get<any>(
        TCAppConfig.GET_SUPPLIERS_CO_LIST,
        params
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  },

  async fetchMaterialLedgerPageServiceRecords(
    params: any
  ): Promise<any> {
    try {
      
      const response = await apiService.get<any>(
        TCAppConfig.GET_MATERIAL_LEDGER,
        params
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  },
};

export const cbLandingPageServiceETrackit = {
  async fetchCbLandingPageServiceRecords(
    params: ICbLandingPageParams
  ): Promise<ICbLandingPageApiResponseETrackit> {
    try {

      const response = await apiService.get<ICbLandingPageApiResponseETrackit>(
        `${AppConfig.BASE_URL}${ETCAppConfig.CERTIFIED_TRANSACTION_DASHBOARD}`,
        params
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  },
};

export const cbLandingPageServiceDTrackit = {
  async fetchCbLandingPageServiceRecords(
    params: any
  ): Promise<ICbLandingPageApiResponse> {
    try {
      // Construct query parameters dynamically
      const queryParams: Record<string, any> = {
        tcCbLicensingCode: params.tcCbLicensingCode,
        limit:  params.limit, // Default to 10 if not provided
        offset: params?.pagination?.pageIndex
          ? params.pagination.pageIndex * (params.pagination.pageSize || 10)
          : 0,
        startDate: params?.startDate || undefined,
        endDate: params?.endDate || undefined,
        buyersCountry: params?.buyersCountry || undefined,
      };
      Utills.cl(`fetchCbLandingPageServiceRecords ${JSON.stringify(queryParams)}`)

      // Make API request
      const response = await apiService.get<ICbLandingPageApiResponse>(
        `${AppConfig.BASE_URL}${TCAppConfig.CERTIFIED_TRANSACTION_DASHBOARD_DTRACKIT}`,
        queryParams
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error; // Propagate the error for caller handling
    }
  },
};

export const cbLandingPageServiceV4 = {
  async fetchCbLandingPageServiceRecords(
    params: any
  ): Promise<ICbLandingPageApiResponse> {
    try {
      const response = await apiService.get<ICbLandingPageApiResponse>(
        TCAppConfig.CERTIFIED_TRANSACTION_DASHBOARD_V4,
        params
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  },
};